export const AZURE_LOGIN = "AZURE_LOGIN";
